// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".purple-tag-gradient{background:linear-gradient(97.59deg,#f3eaff 1.85%,#d8b9ff 94.11%)}.yellow-tag-gradient{background:linear-gradient(97.59deg,#fffabf 1.85%,#faef75 94.11%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
